import React, { useEffect } from "react";
import { DROPDOWN_STYLES } from "../../../constants/theme";
import { useDispatch, useSelector } from "react-redux";
import { change, getFormValues } from "redux-form";
import { DynamicInputFieldProps } from "../../../types/components";
import { RootState } from "../../../types/redux";

import Select from "react-select";
import TextField from "./TextField";

const SelectTextComboField = (props: DynamicInputFieldProps) => {
  const dispatch = useDispatch();
  const values = useSelector((state: RootState) => getFormValues(props.meta.form)(state));
  const multipleInputNames = props.multipleInputNames;

  useEffect(() => {
    if (!multipleInputNames) return;

    dispatch(change(props.meta.form, multipleInputNames.select, ""));
    dispatch(change(props.meta.form, multipleInputNames.text, ""));
  }, []);

  // This field is driven entirely by multipleInputNames, so there is nothing to render without it
  if (!multipleInputNames) return null;

  return (
    <div className="select-text-combo-field">
      <Select
        styles={DROPDOWN_STYLES}
        options={props.options}
        placeholder=""
        isLoading={false}
        onChange={(e: any) => dispatch(change(props.meta.form, multipleInputNames.select, e.value))}
        value={
          props.options?.length && values?.[multipleInputNames.select]
            ? props.options.filter((o) => o.value === values?.[multipleInputNames.select])[0]
            : ""
        }
      />
      <TextField
        id={multipleInputNames.text}
        name={multipleInputNames.text}
        isSensitive={null}
        placehoder={props.placeholder}
        input={{
          value: values?.[multipleInputNames.text] ?? "",
          onChange: (e: string) => dispatch(change(props.meta.form, multipleInputNames.text, e)),
        }}
        maxLength={100}
        disabled={false}
        autoFocus={false}
      />
    </div>
  );
}

export default SelectTextComboField;